import { render, staticRenderFns } from "./EditComplaintModal.vue?vue&type=template&id=37eae6c3"
import script from "./EditComplaintModal.vue?vue&type=script&lang=js"
export * from "./EditComplaintModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports